import * as React from 'react';
import { useState } from 'react';
import { LandingPageMode } from '../../utils/enums';
export interface LandingPageModeContext {
    mode: LandingPageMode;
    setMode: React.Dispatch<React.SetStateAction<LandingPageMode>>;
}

const initState: LandingPageModeContext = {
    mode: LandingPageMode.INIT,
    setMode: () => {},
};

const landingPageModeContext = React.createContext<LandingPageModeContext>(initState);

export function LandingPageModeProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const [mode, setMode] = useState<LandingPageMode>(LandingPageMode.INIT);

    return (
        <landingPageModeContext.Provider value={{ mode: mode, setMode: setMode }}>
            {props.children}
        </landingPageModeContext.Provider>
    );
}

export function useLandingPageModeContext() {
    return React.useContext(landingPageModeContext);
}
